
// import { ConnectorConstant } from "./ConnectorConstant";

import { RequestConstant } from "./RequestConstant";

const RequestAction = {};

RequestAction.getRequestVehicleData = (data) => {

    return {
        type: RequestConstant.REQUEST_VEHICLE_SAGA, 
        payload:data
    }
};

// RequestAction.postConnectorData = (payload) => {
//     return {
//       type: ConnectorConstant.ADD_CONNECTOR_SAGA,
//       payload: payload,
//     };
//   };

export { RequestAction };